import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { logout } from '../services/keyMaster.service';

const Authenticated = () => {
  const user = useSelector((state) => state.user.user);
  const usesSSO = useSelector((state) => state.user.usesSSO);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onLogout = async () => {
    await dispatch(logout({ usesSSO }));
    navigate('/', { replace: true });
  };

  return (
    <div className="login-container authenticated">
      <div className="user-logged">
        <div>{`${user.first_name || user.email} ${
          user.first_name && user.last_name ? user.last_name : ''
        }`}</div>
        <button onClick={onLogout}>Logout</button>
      </div>
    </div>
  );
};

export default Authenticated;
